function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55.5,69.168a77.961,77.961,0,0,1-29.246-6.426,86.342,86.342,0,0,1-12.716-6.77c-1.975-1.344-3.944-2.662-5.8-4.162A61.188,61.188,0,0,1,2.2,46.917a7.365,7.365,0,0,1,.068-10.573,7.753,7.753,0,0,1,7.6-1.831l1.151.348c1.656.5,3.7,1.3,5.579,1.919,1.923.647,3.818,1.329,5.746,1.913,3.831,1.219,7.636,2.322,11.409,3.259a96.14,96.14,0,0,0,22.055,3.125,90.5,90.5,0,0,0,11.075-.592c3.753-.35,7.54-1.011,11.372-1.754s7.7-1.656,11.58-2.682c1.96-.474,3.891-1.049,5.846-1.592,1.9-.524,4-1.2,5.666-1.6l1.208-.287a7.652,7.652,0,0,1,9.226,5.508,7.394,7.394,0,0,1-2.221,7.237,61.79,61.79,0,0,1-5.778,4.662c-1.942,1.4-3.969,2.64-6.012,3.885a82.693,82.693,0,0,1-13.041,6.118,80.982,80.982,0,0,1-28.246,5.192Q55.993,69.174,55.5,69.168ZM23.96,9.614c6.448-12.523,59.488-13.111,64.064,0C91.41,19.314,69.44,32.95,55.993,32.95,41.259,32.951,19.19,18.879,23.96,9.614Z",
  transform: "translate(0 0)",
  fill: "currentColor"
});

function SvgPerfectMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 69.174,
    viewBox: "0 0 112 69.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectMark);
export default __webpack_public_path__ + "static/media/perfect-mark.68258344.svg";
export { ForwardRef as ReactComponent };